"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M12 4.623c2.4033 0 2.6876.0093 3.6369.0525.8774.04 1.354.1865 1.6712.3098a2.7869 2.7869 0 0 1 1.0361.6734 2.788 2.788 0 0 1 .6734 1.036c.1232.3173.2697.7939.3097 1.6713.0433.9492.0525 1.2336.0525 3.6369 0 2.4032-.0092 2.6876-.0525 3.6368-.04.8774-.1865 1.354-.3097 1.6713a2.985 2.985 0 0 1-.6734 1.0346 2.9846 2.9846 0 0 1-1.0347.6734c-.3172.1233-.7938.2697-1.6712.3098-.9489.0432-1.2336.0525-3.6369.0525-2.4032 0-2.688-.0093-3.6368-.0525-.8775-.0401-1.354-.1865-1.6713-.3098a2.7861 2.7861 0 0 1-1.036-.6734 2.7869 2.7869 0 0 1-.6735-1.0361c-.1232-.3172-.2697-.7938-.3097-1.6712-.0432-.9492-.0525-1.2336-.0525-3.6369 0-2.4032.0093-2.6876.0525-3.6368.04-.8775.1865-1.354.3097-1.6713a2.7867 2.7867 0 0 1 .6735-1.036 2.7867 2.7867 0 0 1 1.036-.6735c.3173-.1232.7938-.2697 1.6713-.3097.9492-.0432 1.2336-.0525 3.6368-.0525L12 4.623zM12.0014 3c-2.4443 0-2.7508.0104-3.7108.0543-.96.044-1.6134.1972-2.186.4198a4.4128 4.4128 0 0 0-1.5941 1.0378 4.4127 4.4127 0 0 0-1.036 1.594c-.2244.5728-.3766 1.2269-.4202 2.1847C3.0107 9.2484 3 9.5571 3 12.0014c0 2.4444.0104 2.7509.0543 3.7108.044.96.1958 1.612.4183 2.1847a4.4117 4.4117 0 0 0 1.0379 1.594c.4497.4577.9936.812 1.594 1.0382.5717.2222 1.2269.3744 2.1847.4184.9578.0439 1.2665.0539 3.7108.0539s2.7509-.0103 3.7108-.0539c.96-.0436 1.612-.1962 2.1846-.4184a4.604 4.604 0 0 0 2.6323-2.6322c.2222-.5716.3744-1.2268.4184-2.1847.0439-.9578.0539-1.2664.0539-3.7108 0-2.4443-.0104-2.7508-.0539-3.7108-.0436-.96-.1962-1.612-.4184-2.1846a4.4183 4.4183 0 0 0-1.0382-1.594 4.4124 4.4124 0 0 0-1.5941-1.0361c-.5726-.2244-1.2268-.3766-2.1846-.4202-.9578-.0435-1.2665-.0543-3.7108-.0543L12.0014 3z",
    fill: "url(#a)"
  }), _react.default.createElement("path", {
    d: "M12 7.38a4.622 4.622 0 1 0 0 9.2438A4.622 4.622 0 0 0 12 7.38zm0 7.6214a3.0005 3.0005 0 0 1-2.7725-1.8526A3.001 3.001 0 1 1 12 15.0014z",
    fill: "url(#b)"
  }), _react.default.createElement("path", {
    d: "M16.8044 8.277c.5964 0 1.0799-.4835 1.0799-1.08 0-.5964-.4835-1.08-1.0799-1.08-.5965 0-1.08.4836-1.08 1.08 0 .5965.4835 1.08 1.08 1.08z",
    fill: "#D2006A"
  }), _react.default.createElement("defs", null, _react.default.createElement("linearGradient", {
    id: "a",
    x1: "3.2437",
    y1: "19.3873",
    x2: "17.6257",
    y2: "7.256",
    gradientUnits: "userSpaceOnUse"
  }, _react.default.createElement("stop", {
    offset: ".07",
    stopColor: "#FEBF1E"
  }), _react.default.createElement("stop", {
    offset: ".4",
    stopColor: "#F72C06"
  }), _react.default.createElement("stop", {
    offset: ".75",
    stopColor: "#E80028"
  }), _react.default.createElement("stop", {
    offset: "1",
    stopColor: "#C1019B"
  })), _react.default.createElement("linearGradient", {
    id: "b",
    x1: "8.9605",
    y1: "15.1067",
    x2: "15.0656",
    y2: "8.8698",
    gradientUnits: "userSpaceOnUse"
  }, _react.default.createElement("stop", {
    stopColor: "#F94E0D"
  }), _react.default.createElement("stop", {
    offset: ".24",
    stopColor: "#F03221"
  }), _react.default.createElement("stop", {
    offset: ".54",
    stopColor: "#E61733"
  }), _react.default.createElement("stop", {
    offset: ".8",
    stopColor: "#E1073F"
  }), _react.default.createElement("stop", {
    offset: "1",
    stopColor: "#DF0143"
  })))];
};

exports.default = _default;